import { IdsInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function resetPcrPassword(data: IdsInput) {
  return restApiClient
    .url(constructApiUrl(API.pcr.resetPassword.url, null))
    .post<never, IdsInput>(data)
}
